import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
// import TopicOne from '../container/topic/TopicOne';
// import EmptyOne from '../components/Empty/EmptyOne.jsx';
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const Topic = () => {
  return (
    <React.Fragment>
      <SEO title="Topic Areas | DMBD 2025s" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Topic Areas"
        content="For Authors"
        contentTwo="Topic Areas"
        linkage="/"

      />

      <EmptyTwo>
        <div className="entry-content">
          <table>
            {/* <tbody>
              <tr>
                <th width="140">Data Mining</th>
                <th width="140">Big Data</th>
                <th width="140">FinTech</th>
                <th width="140">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li> Classification and prediction </li>
                    <li> Clustering task</li>
                    <li> Case-Based,Similarity-Based reasoning </li>
                    <li> Mining text, semi-structured, spatio-temporal, streaming, graph,
                      web, multimedia data </li>
                    <li> Systems for data mining </li>
                    <li> Machine learning</li>
                    <li> Reinforcement learning</li>
                    <li> Meta learning</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Data models and architectures </li>
                    <li> Deep learning architectures for handling big data </li>
                    <li> Privacy and security in big data analytics</li>
                    <li> Online and adaptive learning for big data streams </li>
                    <li> Data analytics and metrics </li>
                    <li> Tools and technologies QoS in big data </li>
                    <li> Large-scale text generation model</li>
                    <li> Large-scale generative adversarial network</li>
                    <li> Other large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Quantitative investment</li>
                    <li>Intelligent investment strategy</li>
                    <li>Quantitative strategy</li>
                    <li>Quantization system</li>
                    <li>Market microstructure</li>
                    <li>Risk prediction</li>
                    <li>Credit modeling</li>
                    <li>Financial theories</li>
                    <li>Financial intelligent system</li>
                    <li>Financial Large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Techniques for Big Data Processing </li>
                    <li>Fraud detection and anomaly detection in large-scale datasets</li>
                    <li>Big data analytics for business intelligence</li>
                    <li>Smart city applications and urban analytics</li>
                    <li>Financial data analysis and stock market prediction</li>
                    <li>Recommender systems for online platforms and personalized recommendations</li>
                    <li>Network security</li>
                    <li>Intelligent diagnosis</li>
                    <li>Other applications</li>
                  </ul>
                </td>
              </tr>
            </tbody> */}
<tbody>
  {/* <!-- Data Mining --> */}
  <tr>
    <th width="140">Data Mining</th>
    <td>
      <ul>
        <li>Classification and prediction</li>
        <li>Clustering task</li>
        <li>Case-Based, Similarity-Based reasoning</li>
        <li>Mining text, semi-structured, spatio-temporal, streaming, graph, web, multimedia data</li>
        <li>Systems for data mining</li>
        <li>Machine learning</li>
        <li>Reinforcement learning</li>
        <li>Meta learning</li>
        <li>Fraud detection and anomaly detection</li>
        <li>Financial data analysis and stock market prediction</li>
        <li>Recommender systems</li>
        <li>Network security</li>
        <li>Intelligent diagnosis</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>
  {/* <tr><td colSpan="2"><hr style="border: 2px solid black;"></hr></td></tr> */}

  {/* <!-- Big Data --> */}
  <tr>
    <th width="140">Big Data</th>
    <td>
      <ul>
        <li>Data models and architectures</li>
        <li>Deep learning architectures for handling big data</li>
        <li>Privacy and security in big data analytics</li>
        <li>Online and adaptive learning for big data streams</li>
        <li>Data analytics and metrics</li>
        <li>Tools and technologies QoS in big data</li>
        <li>Large-scale text generation model</li>
        <li>Large-scale generative adversarial network</li>
        <li>Other large-scale models</li>
        <li>Big data analytics for business intelligence</li>
        <li>Smart city applications and urban analytics</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>
  {/* <tr><hr style="border: 2px solid black;"></hr></tr> */}

  {/* <!-- LLM (Large Language Models) --> */}
  <tr>
    <th width="140">Large Language Models</th>
    <td>
      <ul>
        <li>Natural language understanding (NLU)</li>
        <li>Natural language generation (NLG)</li>
        <li>Text summarization</li>
        <li>Machine translation</li>
        <li>Question answering systems</li>
        <li>Dialogue systems and chatbots</li>
        <li>Sentiment analysis</li>
        <li>Named entity recognition (NER)</li>
        <li>Text classification</li>
        <li>Language model fine-tuning</li>
        <li>Multimodal language models</li>
        <li>Ethical considerations in LLMs</li>
        <li>Bias detection and mitigation in LLMs</li>
        <li>LLM applications in healthcare</li>
        <li>LLM applications in legal tech</li>
      </ul>
    </td>
  </tr>
    <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>
  {/* <tr><td colSpan="2"><hr style="border: 2px solid black;"></hr></td></tr> */}

  {/* <!-- Machine Learning --> */}
  <tr>
    <th width="140">Machine Learning</th>
    <td>
      <ul>
        <li>Supervised learning</li>
        <li>Unupervised learning</li>
        <li>Semi-supervised learning</li>
        <li>Deep learning</li>
        <li>Transfer learning</li>
        <li>Online learning</li>
        <li>Ensemble learning</li>
        <li>Explainable AI (XAI)</li>
        <li>Anomaly detection</li>
        <li>Time series analysis</li>
        <li>Computer vision</li>
        <li>Natural language processing (NLP)</li>
        <li>Generative models (e.g., GANs, VAEs)</li>
        <li>Federated learning</li>
      </ul>
    </td>
  </tr>
    <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>
  {/* <tr><td colSpan="2"><hr style="border: 2px solid black;"></hr></td></tr> */}

  {/* <!-- Applications --> */}
  <tr>
    <th width="140">Applications</th>
    <td>
      <ul>
        <li>Techniques for Big Data Processing</li>
        <li>Fraud detection and anomaly detection in large-scale datasets</li>
        <li>Big data analytics for business intelligence</li>
        <li>Smart city applications and urban analytics</li>
        <li>Financial data analysis and stock market prediction</li>
        <li>Recommender systems for online platforms and personalized recommendations</li>
        <li>Network security</li>
        <li>Intelligent diagnosis</li>
        <li>Other applications</li>
      </ul>
    </td>
  </tr>
</tbody>


          </table>
        </div>
      </EmptyTwo>
      {/* <HomeAbout /> */}
      {/* <EmptyOne>
                <p>
                    yifan
                </p>
            <EmptyOne title="Topic Areas | ICSI 2022"/> */}
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Topic;
